import axios from "axios";
import { toast } from "react-toastify";
export const GetAllAccPayable = (data) => {
  return {
    type: "get_allaccpayable",
    payload: data,
    loader: false,
  };
};
export function getallaccpayable() {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Reports/AccountsPayable?projectid=${localStorage.getItem("ProjectId")}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Reports/AccountsPayable`;
    }
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllAccPayable(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
